<template>
  <modal
    v-slot="{ data }"
    name="inAppMessage"
    modal-style="compact"
    :display-header-title="false"
  >
    <in-app-message :message="data" />
  </modal>
</template>


<script>
  import InAppMessage from './in-app-message/index.vue';


  export default {
    name: 'InAppMessageModal',

    components: {
      InAppMessage
    }
  };
</script>
